import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import Modal from '../Modal/Modal';
import Input from '../TextInput/TextInput';
import {labels} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import {documentNameMaxLength} from '../../../util/uiconstants';
import {clearErrors} from '../../../actions/erroractions';
import {updateDocument} from '../../../actions/Document/documentactions';
import ProgressBar from '../../Common/BaseComponentWrappers/MotifProgressBar';

export default function RenameDocument(props) {
	const {
		engagementId,
		document,
		onDocumentRenamed,
		showRenameModal,
		setShowRenameModal,
		viewKey,
		entityUId,
		maxNameLength,
		title = labels.renameFileTitle,
		cancelLabel = labels.cancelLabel,
		confirmLabel = labels.confirmLabel,
		isAresView
	} = props;

	const [documentName, setDocumentName] = useState(document?.documentName);
	const [isRenaming, setIsRenaming] = useState(false);
	const [error, setError] = useState();
	const [errorMessage, setErrorMessage] = useState();
	const [inputChanged, setInputChanged] = useState(false);

	const dispatch = useDispatch();

	useEffect(() => {
		return () => {
			dispatch(clearErrors());
		};
	}, []);

	useEffect(() => {
		if (inputChanged && documentName !== document.documentName) {
			validateDocumentName();
			setInputChanged(false);
		}
	}, [documentName]);

	const handlerRenameDocument = () => {
		const validationResult = validateDocumentName(documentName);
		const isValid = !validationResult.find((x) => x === true);

		if (document.documentName !== documentName && isValid) {
			setIsRenaming(true);
			dispatch(
				updateDocument(
					engagementId,
					document.id,
					{
						code: 4,
						documentName: documentName.trim(),
						fileExt: document.fileExt
					},
					undefined,
					undefined,
					undefined,
					entityUId,
					viewKey
				)
			).then((result) => {
				if (typeof onDocumentRenamed === 'function') {
					onDocumentRenamed(document, documentName);
				}
				setIsRenaming(false);
				setShowRenameModal(false);
			});
		}
	};

	const validateDocumentName = (name) => {
		const [error, errorMessage] = Utility.validateDocumentName(name);

		setError(error);
		setErrorMessage(errorMessage);

		return [error, errorMessage];
	};

	const onInputChange = (e) => {
		let value = e.target.value.slice(0, maxNameLength);

		setDocumentName(value);
		if (error) {
			setError(false);
			setErrorMessage(null);
		}
	};

	return (
		<Wrapper className="RenameDocumentWrapper">
			<Modal
				title={title}
				onOkClick={() => handlerRenameDocument()}
				onHide={() => setShowRenameModal(false)}
				show={showRenameModal}
				modalsize="small"
				showButtons
				closeBtnTitle={cancelLabel}
				confirmBtnTitle={confirmLabel}
				closeTitle={labels.closeLabel}
				isOkButtonDisabled={isRenaming || error}
				isCancelButtonDisabled={isRenaming}
				modalContainerClass={`RenameDocumentModalContainer ${isAresView ? 'AresRenameDocumentModalContainer' : ''}`}
				modalbodystyle={`RenameDocumentModalBody ${isAresView ? 'AresRenameDocumentModalBody' : ''}`}
				isAresView={isAresView}
			>
				<StyledRenameDocument className="RenameDocument">
					{isRenaming ? (
						// <LoadingIndicator fullScreen show={isRenaming} />
						<section className="MotifProgressBarWrapper">
							<ProgressBar isIndeterminate />
						</section>
					) : (
						<Input
							onInputChange={onInputChange}
							inputVal={documentName}
							showinputerror={error}
							errormessage={errorMessage}
							clearButtonTitle={labels.clear}
							label={labels.name}
							placeholder={labels.nameLabel}
							wrapperClass={'RenameDocumentWrapper'}
						/>
					)}
				</StyledRenameDocument>
			</Modal>
		</Wrapper>
	);
}

RenameDocument.defaultProps = {
	maxNameLength: documentNameMaxLength
};

const Wrapper = styled.section`
	.motif-modal-content {
		.motif-modal-body.RenameDocumentModalBody {
			min-height: var(--px-100);
		}
	}
`;

const StyledRenameDocument = styled.section`
	font-size: var(--px-14);
	padding: var(--px-30) var(--px-20);
	min-height: var(--px-130);
	.MotifProgressBarWrapper {
		.motif-progress-bar-wrapper {
			width: calc(100% - var(--px-48));
			top: 40%;
		}
	}
	.noTypeAhead {
		.motif-input-component {
			.motif-input {
				width: 100%;
				min-height: var(--px-45);
			}
		}
	}
	.confirm-msg {
		margin: 0 0 var(--px-20) 0;
		font-weight: bold;
		font-size: var(--px-14);
	}
	.DocumentNameWrapper {
		padding: 0;
		.DocumentName {
			font-size: var(--px-14);
		}
		.DocumentSVG {
			svg {
				cursor: default;
			}
		}
	}
`;
